// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation, Pagination, Autoplay } from 'swiper/modules';
// import { FaStar, FaStarHalfAlt, FaRegStar, FaQuoteLeft } from 'react-icons/fa';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
// import { motion } from 'framer-motion';

// const reviews = [
//   { name: 'Mack Jr.', country: '🇺🇸', review: 'The execution speed is phenomenal, and I have never experienced slippage! Highly recommend to all Forex traders.', rating: 5 },
//   { name: 'Sarah L.', country: '🇬🇧', review: 'Spreads are unbeatable, and customer support is top-notch. A reliable platform for all my trading needs.', rating: 5 },
//   { name: 'Mark T.', country: '🇨🇦', review: 'This platform has changed my trading game completely! Lightning-fast orders and excellent liquidity!', rating: 5 },
//   { name: 'Anna P.', country: '🇩🇪', review: 'Exceptional service, quick withdrawals, and always reliable. Best trading platform I have used so far.', rating: 5 },
//   { name: 'David B.', country: '🇦🇺', review: 'I've been trading for over 10 years, and this platform is the most user-friendly I've encountered. Excellent.', rating: 5 },
//   { name: 'Lisa M.', country: '🇳🇬', review: 'Very secure and reliable. I've never felt more confident in trading since I started using this platform.', rating: 5 },
//   { name: 'James C.', country: '🇸🇬', review: 'The customer service is phenomenal! They answered all my queries and helped me with account setup.', rating: 5 },
//   { name: 'Emily R.', country: '🇿🇦', review: 'Great platform with amazing tools for charting and analysis. Trading has never been easier.', rating: 5 },
// ];

// function StarRating({ rating }) {
//   return (
//     <div className="flex gap-0.5 mt-1">
//       {[1, 2, 3, 4, 5].map((star) => (
//         <span key={star} className="text-sm">
//           {star <= Math.floor(rating)
//             ? <FaStar className="text-yellow-400" />
//             : star - 0.5 <= rating
//             ? <FaStarHalfAlt className="text-yellow-400" />
//             : <FaRegStar className="text-slate-600" />}
//         </span>
//       ))}
//     </div>
//   );
// }

// export default function CustomerReviews() {
//   return (
//     <section id="reviews" className="py-24 px-6 relative overflow-hidden" style={{ background: "var(--uea-dark)" }}>
//       <div className="absolute inset-0 grid-bg opacity-30" />

//       <div className="max-w-7xl mx-auto relative z-10">
//         <div className="text-center mb-16">
//           <span className="text-xs font-mono-code text-green-400 tracking-widest uppercase">// Client Testimonials</span>
//           <motion.h2
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             className="font-orbitron font-black text-3xl sm:text-4xl text-white mt-4"
//           >
//             What Our{" "}
//             <span style={{ background: "linear-gradient(135deg, #22c55e, #3b82f6)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
//               Traders Say
//             </span>
//           </motion.h2>
//           <p className="text-slate-400 mt-4 max-w-xl mx-auto">
//             Real results from real traders across the globe using UEA Trading Software.
//           </p>
//         </div>

//         <Swiper
//           modules={[Navigation, Pagination, Autoplay]}
//           spaceBetween={24}
//           slidesPerView={1}
//           autoplay={{ delay: 4000, disableOnInteraction: false }}
//           breakpoints={{ 640: { slidesPerView: 1 }, 768: { slidesPerView: 2 }, 1024: { slidesPerView: 3 } }}
//           navigation
//           className="pb-12"
//         >
//           {reviews.map((r, i) => (
//             <SwiperSlide key={i}>
//               <motion.div
//                 initial={{ opacity: 0, y: 20 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ delay: i * 0.05 }}
//                 className="rounded-2xl p-6 h-full border"
//                 style={{ background: "var(--uea-card)", borderColor: "rgba(59,130,246,0.1)" }}
//               >
//                 {/* Quote icon */}
//                 <div className="mb-4">
//                   <FaQuoteLeft className="text-2xl" style={{ color: "rgba(34,197,94,0.3)" }} />
//                 </div>
//                 <p className="text-slate-300 text-sm leading-relaxed mb-6">{r.review}</p>
//                 <div className="flex items-center gap-3 mt-auto">
//                   <div className="w-10 h-10 rounded-full flex items-center justify-center text-white font-orbitron font-bold text-sm" style={{ background: "linear-gradient(135deg, #22c55e, #3b82f6)" }}>
//                     {r.name[0]}
//                   </div>
//                   <div>
//                     <div className="text-white font-semibold text-sm flex items-center gap-2">
//                       {r.name} <span>{r.country}</span>
//                     </div>
//                     <StarRating rating={r.rating} />
//                   </div>
//                 </div>
//               </motion.div>
//             </SwiperSlide>
//           ))}
//         </Swiper>
//       </div>
//     </section>
//   );
// }

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { motion } from 'framer-motion';

const reviews = [
  { name: 'Mack Jr.', country: '🇺🇸', review: `The execution speed is phenomenal, and I have never experienced slippage! Highly recommend to all Forex traders.`, rating: 5 },
  { name: 'Sarah L.', country: '🇬🇧', review: `Spreads are unbeatable, and customer support is top-notch. A reliable platform for all my trading needs.`, rating: 5 },
  { name: 'Mark T.', country: '🇨🇦', review: `This platform has changed my trading game completely! Lightning-fast orders and excellent liquidity!`, rating: 5 },
  { name: 'Anna P.', country: '🇩🇪', review: `Exceptional service, quick withdrawals, and always reliable. Best trading platform I have used so far.`, rating: 5 },
  { name: 'David B.', country: '🇦🇺', review: `I've been trading for over 10 years, and this platform is the most user-friendly I've encountered. Excellent.`, rating: 5 },
  { name: 'Lisa M.', country: '🇳🇬', review: `Very secure and reliable. I've never felt more confident in trading since I started using this platform.`, rating: 5 },
  { name: 'James C.', country: '🇸🇬', review: `The customer service is phenomenal! They answered all my queries and helped me with account setup.`, rating: 5 },
  { name: 'Emily R.', country: '🇿🇦', review: `Great platform with amazing tools for charting and analysis. Trading has never been easier.`, rating: 5 },
];

function StarRating({ rating }) {
  return (
    <div className="flex gap-0.5">
      {[...Array(5)].map((_, i) => (
        <span key={i} className={i < Math.floor(rating) ? "text-yellow-400" : "text-slate-600"}>★</span>
      ))}
    </div>
  );
}

export default function CustomerReviews() {
  return (
    <section id="reviews" className="py-24 px-6 relative overflow-hidden" style={{ background: "var(--uea-dark, #0f172a)" }}>
      <div className="absolute inset-0 grid-bg opacity-30" />

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <span className="text-xs font-mono text-green-400 tracking-widest uppercase">// Client Testimonials</span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="font-orbitron font-black text-3xl sm:text-4xl text-white mt-4"
          >
            What Our{" "}
            <span style={{ background: "linear-gradient(135deg, #22c55e, #3b82f6)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
              Traders Say
            </span>
          </motion.h2>
          <p className="text-slate-400 mt-4 max-w-xl mx-auto">
            Real results from real traders across the globe using UEA Trading Software.
          </p>
        </div>

        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={24}
          slidesPerView={1}
          autoplay={{ delay: 4000, disableOnInteraction: false }}
          breakpoints={{ 
            640: { slidesPerView: 1 }, 
            768: { slidesPerView: 2 }, 
            1024: { slidesPerView: 3 } 
          }}
          navigation
          pagination={{ clickable: true }}
          className="pb-12 testimonial-swiper"
        >
          {reviews.map((r, i) => (
            <SwiperSlide key={i} className="h-auto">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.05 }}
                className="rounded-2xl p-6 h-full border flex flex-col"
                style={{ 
                  background: "var(--uea-card, #1e293b)", 
                  borderColor: "rgba(59,130,246,0.1)" 
                }}
              >
                {/* Quote mark */}
                <div className="text-4xl font-serif leading-none mb-4" style={{ color: "rgba(34,197,94,0.3)" }}>"</div>
                
                <p className="text-slate-300 text-sm leading-relaxed mb-6 flex-grow">{r.review}</p>
                
                <div className="flex items-center gap-3">
                  <div 
                    className="w-10 h-10 rounded-full flex items-center justify-center text-white font-orbitron font-bold text-sm shrink-0" 
                    style={{ background: "linear-gradient(135deg, #22c55e, #3b82f6)" }}
                  >
                    {r.name[0]}
                  </div>
                  <div>
                    <div className="text-white font-semibold text-sm flex items-center gap-2">
                      {r.name} <span>{r.country}</span>
                    </div>
                    <StarRating rating={r.rating} />
                  </div>
                </div>
              </motion.div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      
      <style jsx>{`
        :global(.swiper-button-next), :global(.swiper-button-prev) {
          color: #22c55e !important;
          transform: scale(0.7);
        }
        :global(.swiper-pagination-bullet-active) {
          background: #22c55e !important;
        }
      `}</style>
    </section>
  );
}